import { render } from "./EtudesService.vue?vue&type=template&id=2be45ce6&scoped=true"
import script from "./EtudesService.vue?vue&type=script&lang=js"
export * from "./EtudesService.vue?vue&type=script&lang=js"

import "./EtudesService.vue?vue&type=style&index=0&id=2be45ce6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be45ce6"]])

export default __exports__